/** @jsxImportSource @emotion/react */
import React from "react";
import { Modal, ModalProps } from "antd";
import { css } from "@emotion/react";
import { effects } from "./effects";
import { StyledText } from "../assets/typography/typography";
import { colors } from "./colors";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  header?: string;
  subtitle?: string;
  headerActionButtons?: React.ReactNode;
  headerComponent?: React.ReactNode;
} & ModalProps;

const modalStyle = css`
  display: flex;
  flex-direction: column;
  background-color: ${colors.white};
  box-shadow: ${effects.modal};
  border-radius: 8px;
  height: 95vh;
`;

const headerStyle = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

const headerWrapperStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 24px 24px 24px 24px;
`;

export const FullScreenModal = ({
  isOpen,
  onClose,
  children,
  header,
  subtitle,
  closable,
  headerActionButtons,
  headerComponent,
  ...rest
}: Props) => {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      centered
      styles={{
        mask: {
          height: "100vh",
        },
      }}
      width="100%"
      style={{
        pointerEvents: "auto",
      }}
      modalRender={() => (
        <div css={modalStyle}>
          <div css={headerWrapperStyle}>
            <div css={headerStyle}>
              {headerComponent || (
                <StyledText className="headerFour mb-0">{header}</StyledText>
              )}
              {subtitle && (
                <StyledText className="bodyTextRegular mb-0">
                  {subtitle}
                </StyledText>
              )}
            </div>
            {headerActionButtons}
          </div>
          {children}
        </div>
      )}
      {...rest}
    />
  );
};
